module.exports = __webpack_public_path__ + "static/media/received_1638421619526276.302f53f4.jpeg";